import { useEffect, useState } from "react";
import { GetCustomerHistoryResponse } from "../../types/apimodel";
import LinkedappBackend from "../../services/LinkedappBackend";
import useFilterCtx from "../reporting/filterpanel/useFilterCtx";

const useCustomerHistoryData = () : readonly[
    loading:boolean, 
    error:string | undefined, 
    customerHistoryData: GetCustomerHistoryResponse | undefined,
    resetError: () => void
 ] => {
    const {orderBy, sortOrder} = useFilterCtx();
    console.log("Update filter", `Sort: ${sortOrder}, Order: ${orderBy}`)
    const [customerHistoryData, setCustomerHistoryData] = useState(undefined as GetCustomerHistoryResponse | undefined);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined as string | undefined);



    const refreshCustomerHistory = ():boolean => {
        const stringRegistrien = "landing/registrieren";

        const url = window.location.href;

        
        if (url.indexOf(stringRegistrien) !== -1){
            return false;
        } else {
            return true;
        }

    }
    
    
    useEffect(() => {
        setLoading(true);
        setError(undefined);
        if (refreshCustomerHistory()){
            console.log("Trigger request")
            LinkedappBackend.getCustomerHistory(orderBy, sortOrder).then((data) => {
                console.log("Retrieved data", data)
                if (data !== undefined && data !== null) {
                    setCustomerHistoryData(data);
                }
                setLoading(false);
            }).catch(error => {
                console.log('error in getCustomerHistory: ' + JSON.stringify(error));
                setError("Fehler beim Holen der Daten: " + ((error !== null && error.details !== null) ? error.details : JSON.stringify(error)));
                setLoading(false);
            });
        }
    }, [orderBy, sortOrder]);

    const resetError = () => {
        setError(undefined);
    }

    return [loading, error, customerHistoryData, resetError] as const;
}

export default useCustomerHistoryData;